import React from 'react';
import i18next from 'i18next';
import {
  THeader,
  TTableBody,
  TTableRow
} from '../../../shared_components/vrr_table/types';
import { TCreativeRow } from './types';
import { TCreativeElements } from '../../../../redux/creativeAnalytics/creativeVideoDetails/types';

export const prepareHeader = (): THeader['element'][] => {
  return [
    {
      id: 'name',
      component: (
        <div>
          {i18next.t(
            'creative_video_details.creative_elements.table.header.name'
          )}
        </div>
      )
    },
    {
      id: 'category',
      component: (
        <div>
          {i18next.t(
            'creative_video_details.creative_elements.table.header.category'
          )}
        </div>
      )
    },
    {
      id: 'type',
      component: (
        <div>
          {i18next.t(
            'creative_video_details.creative_elements.table.header.type'
          )}
        </div>
      )
    }
  ];
};

const getLine = (line: TCreativeRow[]): TTableRow['cellElements'] => {
  return line?.map((cell) => {
    return {
      headerId: cell.headerId,
      id: cell.rowId,
      component: <div>{cell.value}</div>,
      value: cell.value
    };
  });
};

export const prepareLine = (line: {
  element_id: string;
  creative: TCreativeElements;
}): TCreativeRow[] => {
  return Object.keys(line.creative)?.map((key) => {
    return {
      headerId: key,
      rowId: line.element_id,
      value:
        key === 'name'
          ? i18next.t(
              `creative_tags.${line.creative[key as keyof TCreativeElements]}`
            )
          : line.creative[key as keyof TCreativeElements] ?? '-'
    };
  });
};

export const prepareBody = (
  creatives?: TCreativeElements[]
): TTableBody['rowElements'] => {
  const newBody: TTableBody['rowElements'] = [];
  creatives?.forEach((creative, index) => {
    const line = prepareLine({
      element_id: index.toString(),
      creative
    });
    newBody.push(getLine(line));
  });

  return newBody;
};
